import { IncomePrimary } from '@/types/models/income';

export const getIncomes = (): IncomePrimary[] => {
  return [
    { id: 1, display_amount: '150万円' },
    { id: 2, display_amount: '200万円' },
    { id: 3, display_amount: '250万円' },
    { id: 4, display_amount: '300万円' },
    { id: 5, display_amount: '350万円' },
    { id: 6, display_amount: '400万円' },
    { id: 7, display_amount: '450万円' },
    { id: 8, display_amount: '500万円' },
    { id: 9, display_amount: '550万円' },
    { id: 10, display_amount: '600万円' },
    { id: 11, display_amount: '650万円' },
    { id: 12, display_amount: '700万円' },
    { id: 13, display_amount: '750万円' },
    { id: 14, display_amount: '800万円' },
    { id: 15, display_amount: '850万円' },
    { id: 16, display_amount: '900万円' },
    { id: 17, display_amount: '950万円' },
    { id: 18, display_amount: '1000万円' },
    { id: 19, display_amount: '1100万円' },
    { id: 20, display_amount: '1200万円' },
    { id: 21, display_amount: '1300万円' },
    { id: 22, display_amount: '1400万円' },
    { id: 23, display_amount: '1500万円' },
    { id: 24, display_amount: '1600万円' },
    { id: 25, display_amount: '1700万円' },
    { id: 26, display_amount: '1800万円' },
    { id: 27, display_amount: '1900万円' },
    { id: 28, display_amount: '2000万円' },
    { id: 29, display_amount: '2500万円' },
    { id: 30, display_amount: '3000万円' },
    { id: 31, display_amount: '3500万円' },
    { id: 32, display_amount: '4000万円' },
    { id: 33, display_amount: '4500万円' },
    { id: 34, display_amount: '5000万円' },
    { id: 35, display_amount: null },
  ];
};
